export const scrollIntoElement = (id: string) => {
	const findElement = document.getElementById(id);
	if (!findElement) return;

	findElement.scrollIntoView({
		block: "end",
		inline: "end",
	});
};
